/**
 * Vue mixin for common locations screens data and mounted logic.
 * @author bmk11u
 */
// import $cookies from 'vue-cookies'
import * as lst from '@/components/localStorage.js'

export default {
  data () {
    return {
      authenticated: lst.getValue('authenticated')
    }
  },
  mounted () {
    if (!this.authenticated) {
      document.title = 'Room Finder'
    }
  },
  methods: {
    // Goes back to previous router location
    goBack () {
      if (this.$route.query.auto) {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
